var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlannerWorkbookIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2546_2015)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2546_2015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103 49.5C103 76.8 80.8 99 53.5 99C26.2 99 4 76.8 4 49.5C4 22.2 26.2 0 53.5 0C80.8 0 103 22.2 103 49.5Z",
    fill: "#E26D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 32.1001H27.6C27 32.1001 26.6 32.6001 26.6 33.1001C26.6 33.7001 27.1 34.1001 27.6 34.1001H45.5C46.1 34.1001 46.5 33.6001 46.5 33.1001C46.5 32.6001 46 32.1001 45.5 32.1001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 39.1001H27.6C27 39.1001 26.6 39.6001 26.6 40.1001C26.6 40.7001 27.1 41.1001 27.6 41.1001H45.5C46.1 41.1001 46.5 40.6001 46.5 40.1001C46.5 39.6001 46 39.1001 45.5 39.1001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 46.1001H27.6C27 46.1001 26.6 46.6001 26.6 47.1001C26.6 47.7001 27.1 48.1001 27.6 48.1001H45.5C46.1 48.1001 46.5 47.6001 46.5 47.1001C46.5 46.6001 46 46.1001 45.5 46.1001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 53.2002H27.6C27 53.2002 26.6 53.7002 26.6 54.2002C26.6 54.7002 27.1 55.2002 27.6 55.2002H45.5C46.1 55.2002 46.5 54.7002 46.5 54.2002C46.5 53.7002 46 53.2002 45.5 53.2002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5 22.7002H60.6C57.3 22.7002 54.4 24.6002 52.9 27.3002C51.5 24.6002 48.5 22.7002 45.2 22.7002H21.3C20.7 22.7002 20.3 23.2002 20.3 23.7002V71.0002C20.3 71.6002 20.8 72.0002 21.3 72.0002H46.5C47.9 72.0002 49.3 72.6002 50.2 73.6002C51.2 74.6002 51.8 75.9002 51.8 77.3002C51.8 77.9002 52.3 78.3002 52.8 78.3002C52.8 78.3002 52.8 78.3002 52.9 78.3002C52.9 78.3002 52.9 78.3002 53 78.3002C53.6 78.3002 54 77.8002 54 77.3002C54 75.9002 54.6 74.5002 55.6 73.6002C56.6 72.6002 57.9 72.0002 59.3 72.0002H84.5C85.1 72.0002 85.5 71.5002 85.5 71.0002V23.7002C85.5 23.1002 85.1 22.7002 84.5 22.7002ZM51.8 72.3002L51.7 72.2002C50.3 70.8002 48.5 70.1002 46.5 70.1002H22.3V24.7002H45.2C48.8 24.7002 51.8 27.7002 51.8 31.3002V72.3002ZM83.5 70.0002H59.3C57.3 70.0002 55.5 70.8002 54.1 72.1002L54 72.2002V31.2002C54 27.6002 57 24.6002 60.6 24.6002H83.5V70.0002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3 33.1001C59.3 33.7001 59.8 34.1001 60.3 34.1001H78.2C78.8 34.1001 79.2 33.6001 79.2 33.1001C79.2 32.5001 78.7 32.1001 78.2 32.1001H60.3C59.8 32.1001 59.3 32.6001 59.3 33.1001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2 39.1001H60.3C59.7 39.1001 59.3 39.6001 59.3 40.1001C59.3 40.7001 59.8 41.1001 60.3 41.1001H78.2C78.8 41.1001 79.2 40.6001 79.2 40.1001C79.2 39.6001 78.8 39.1001 78.2 39.1001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2 46.1001H60.3C59.7 46.1001 59.3 46.6001 59.3 47.1001C59.3 47.7001 59.8 48.1001 60.3 48.1001H78.2C78.8 48.1001 79.2 47.6001 79.2 47.1001C79.2 46.6001 78.8 46.1001 78.2 46.1001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2 53.2002H60.3C59.7 53.2002 59.3 53.7002 59.3 54.2002C59.3 54.7002 59.8 55.2002 60.3 55.2002H78.2C78.8 55.2002 79.2 54.7002 79.2 54.2002C79.2 53.7002 78.8 53.2002 78.2 53.2002Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2546_2015",
    x: 0,
    y: 0,
    width: 107,
    height: 107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2546_2015"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2546_2015",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2546_2015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 107,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlannerWorkbookIcon);
export default __webpack_public_path__ + "static/media/planner-workbook-icon.f3f7cae2ffab31e43bf291e34e7e0d9f.svg";
export { ForwardRef as ReactComponent };